<template>
  <div class="stat-box w-x24 p-x2 br-12 f-v" :class="{ 'primary': primary, 'o-50': disabled, 'c-not-allowed': disabled }">
    <div class="f-ac">
      <div class="w-x6 h-x6 round f f-ac f-jc icon-wrapper">
        <lucide-icon :name="icon" :size="32" :stroke-width="2" class="lh-1" />
      </div>
      <slot class="slot">
        <button v-if="button && button.action" :class="buttonClasses" :action="button.action" :disabled="button.disabled">
          {{ button.label }}
        </button>
        <a v-else-if="button && button.href" :class="buttonClasses" :href="!button.disabled && button.href">
          {{ button.label }}
        </a>
      </slot>
    </div>
    <div class="t demibold m-tx3 stat-box-title">{{ title }}</div>
    <div class="f-ac f-gap-8 m-t">
      <div class="t-xx demibold" :class="{ 'white': primary }">{{ stat.toLocaleString() }}</div>
      <div v-if="emoji" v-emoji="`:${emoji}:`" class="t-xxl lh-1 emoji" />
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    title: { type: String, required: true },
    stat: { type: Number, required: true },
    emoji: { type: String, default: null },
    primary: { type: Boolean, default: false },
    icon: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    button: {
      type: Object,
      required: false,
      default: null,
      validator: (value) => {
        if (value === null) return true;
        return (
          typeof value === 'object'
          && (value.label && typeof value.label === 'string')
          && (value.href || value.action)
        );
      },
    },
  });

  const buttonClasses = computed(() => {
    if (!props.button) return '';
    return `button sm bold${props.primary ? ' white' : ''}${props.button.classes ? ` ${props.button.classes}` : ''}`;
  });
</script>
<style scoped lang='scss'>
  @import '../../../styles/donut';
  .icon-wrapper {
    background-color: rgba($black, 0.1);
    color: $black;
  }
  .stat-box-title {
    color: $dark-gray;
  }
  .stat-box {
    background-color: $purple-bg;
  }
  .primary {
    background: $purple-gradient;
    box-shadow: $shadow-purple;
    .icon-wrapper {
      background-color: rgba($white, 0.15);
      color: $white;
    }
    > .stat-box-title {
      color: rgba($white, 0.75);
    }
  }
  .button, .a {
    margin-left: auto;
  }
  .emoji {
    filter: drop-shadow(0px 4px 2px rgba(0, 0,0, 0.15));
  }
</style>
